// listen to Elementor appending `elementor-message` to their
// forms and moving them before the form's fields
// (function ($) {
//   var origAppend = $.fn.append;
//   $.fn.append = function () {
//     return origAppend.apply(this, arguments).trigger('append');
//   };
// })(jQuery);

// jQuery(function ($) {
//   $('.elementor-form').bind('append', function (e) {
//     var curr = $(this).children('.elementor-message');
//     curr.prependTo(curr.parent());
//   });
// });
